<template>
  <div class="top-backview">
    <div class="contnet-backview">
      <!-- 顶部菜单 -->
      <!-- <Topbar class="topbar"></Topbar> -->
      <!-- banner -->
      <div class="dibannerclass">
        <el-carousel
          :interval="3000"
          indicator-position="none"
          id="el-carousel"
          :height="dataHeight"
        >
          <el-carousel-item v-for="item in images" :key="item.index">
            <img :src="item.url" alt="" class="banner-img-class" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="bannerbottom">
        <div class="title-backview">汉语语言素养素拓课</div>
      </div>
      <div class="red-backview">
        <div class="red-lineview"></div>
      </div>
      <!-- 中间内容部分 -->
      <div class="centerclass">
        <div class="center-titleview">
          <div class="titleStr">课程标准</div>
        </div>
        <div class="course-standard-backview">
          <img
            src="https://cdn.spbcn.org/ghac/assets/program1_3_part1.png"
            alt=""
            class="program1_3_part1class"
          />
        </div>
        <div class="center-titleview">
          <div class="titleStr">课程标准</div>
        </div>
        <div class="course-standard-backview">
          <img
            src="https://cdn.spbcn.org/ghac/assets/program1_3_part2.png"
            alt=""
            class="program1_3_part2class"
          />
        </div>
        <div class="course-standard-backview margin-bottom">
          <div class="course-standard-titleback">汉字名片</div>
          <img
            src="https://cdn.spbcn.org/ghac/assets/program1_3_part3.png"
            alt=""
            class="program1_3_part3class"
          />
          <div class="course-standard-titleback">汉字找朋友</div>
          <img
            src="https://cdn.spbcn.org/ghac/assets/program1_3_part4.png"
            alt=""
            class="program1_3_part4class"
          />
        </div>
      </div>
      <!-- 底部内容 -->
    </div>
  </div>
</template>

<script>
// import Topbar from '@/components/Topbar.vue'
// import Footer from '@/components/Footer.vue'
export default {
  props: {
    dataHeight: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      images: [{ url: 'https://cdn.spbcn.org/ghac/assets/program1_3banner.png' }]
    }
  },
  components: {
    // Topbar,
    // Footer
  }
}
</script>

<style lang="less" scoped>
// .topbar {
//   z-index: 1000;
//   width: 1000px;
//   padding: 0;
//   margin: 0;
// }
.contnet-backview {
  width: 1000px;
  background-color: black;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.top-backview {
  width: 100%;
  // padding-bottom: 10px;
  background-color: rgb(216, 216, 216);
  display: flex;
  align-items: center;
  flex-direction: column;
}
.dibannerclass {
  width: 1000px;
  height: 469px;
  z-index: 99;
  background-color: rgb(0, 0, 0);
}
.bannerbottom {
  width: 1000px;
  height: 100px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 150px;
  z-index: 100;
}
.title-backview {
  height: 60px;
  font-size: 32px;
  font-family: FZLBJW;
  font-weight: 900;
  text-align: center;
  line-height: 60px;
  padding: 0px 20px;
  color: white;
  border: 2px solid rgb(255, 255, 255);
}
.red-backview {
  width: 1000px;
  height: 25px;
}
.red-lineview {
  width: 1000px;
  height: 6px;
  margin-top: 15px;
  background-color: #e50211;
}
.centerclass {
  width: 1000px;
  // height: 1453px;
  display: flex;
  flex-direction: column;
  background-image: url(https://cdn.spbcn.org/ghac/assets/feiyi_background_mix.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.center-titleview {
  width: 377px;
  height: 42px;
  margin-top: 30px;
  background: url(https://cdn.spbcn.org/ghac/assets/feiyi_homepage_title.png);
  background-size: 100%;
}

.titleStr {
  width: 280px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-size: 24px;
  font-family: FZLBJW;
  color: white;
  font-weight: bolder;
}

.footerclass {
  width: 1000px;
}
.banner-img-class {
  width: 1000px;
  height: 470px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.el-carousel {
  width: 1000px;
  height: 470px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  font-family: FZLBJW;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.course-standard-backview {
  width: 800px;
  margin-left: 60px;
  margin-top: 30px;
  padding: 50px 40px;
  background-color: #ffffff;
  border-radius: 30px;
}
.margin-bottom {
  margin-bottom: 30px;
}
.program1_3_part1class {
  width: 800px;
  height: 563px;
}
.program1_3_part2class {
  width: 800px;
  height: 450px;
}
.course-standard-titleback {
  width: 300px;
  height: 44px;
  margin-left: 250px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  font-family: FZLBJW;
  color: white;
  line-height: 44px;
  display: flex;
  flex-direction: column;
  background-image: url(https://cdn.spbcn.org/ghac/assets/programs4_2_button.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.program1_3_part3class {
  width: 800px;
  height: 195px;
  margin-bottom: 30px;
}
.program1_3_part4class {
  width: 800px;
  height: 233px;
}
</style>
